const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 60 * 24;

export type CalendarEventReminderLabel = {
  key: string;
  count?: number;
};

// Returns a translation descriptor rather than a string so both platforms render the same
// label through their own `t` without this util depending on an i18n instance.
export const getCalendarEventReminderLabel = (
  minutes: number,
): CalendarEventReminderLabel => {
  if (minutes === 0) {
    return { key: 'forms.event.fields.reminders.at-time-of-event' };
  }

  if (minutes % MINUTES_PER_DAY === 0) {
    return {
      key: 'forms.event.fields.reminders.days-before',
      count: minutes / MINUTES_PER_DAY,
    };
  }

  if (minutes % MINUTES_PER_HOUR === 0) {
    return {
      key: 'forms.event.fields.reminders.hours-before',
      count: minutes / MINUTES_PER_HOUR,
    };
  }

  return { key: 'forms.event.fields.reminders.minutes-before', count: minutes };
};
